import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchEcomOrderDetails } from '../redux/PerformanceReducer/Ecommerce/ecomOrderDetailsSlice';
import { selectIsMultiStoreEnabled, selectUserDetails } from '../redux/UserReducer/userSlice';
import { getEffectiveStoreNumber } from '../utils/appUtils';

export const useEcomOrderDetailsData = (): void => {
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector(selectUserDetails);
  const isMultiStoreEnabled = useAppSelector(selectIsMultiStoreEnabled);

  const effectiveStoreNumber = useMemo(
    () => getEffectiveStoreNumber(userDetails, isMultiStoreEnabled),
    [userDetails, isMultiStoreEnabled],
  );

  useEffect(() => {
    if (!effectiveStoreNumber) return;
    dispatch(
      fetchEcomOrderDetails({
        storeNumber: effectiveStoreNumber,
        isMultiStoreMode: isMultiStoreEnabled,
      }),
    );
  }, [dispatch, effectiveStoreNumber, isMultiStoreEnabled]);
};
